import { render, staticRenderFns } from "./DotsHorizontal.vue?vue&type=template&id=1b9b004d&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DotsHorizontal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/DotsHorizontal.vue
// module id = 2296
// module chunks = 1